export function createIframe(container: HTMLElement, iframeId: string): HTMLIFrameElement {
  const iframe = document.createElement('iframe')
  iframe.name = iframeId
  iframe.id = iframeId
  iframe.allow = 'clipboard-write; payment'
  iframe.style.cssText = 'flex:1;width:100%;min-height:0;border:none;display:block;'
  container.appendChild(iframe)
  return iframe
}
